import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useCallback, useEffect, useState } from "react";
import { MarkDown, mixins } from "@sy/component-library";
import Avatar from "~/components/Avatar";
import FullscreenVideoModal from "~/components/FullscreenVideoModal";
import { CTARow, ContainerImage640x560, FaqBlock, FaqBlockImage, FaqBlockLi, FaqBlockLink, FaqBlockOl, FaqBlockText, FaqBlockUl, Header, HeroImage, Highlight, ImageBlock, ResponsiveText, Signup, Video640x560, Testimonial, Usp } from "~/components/Marketing";
import LinkBody from "~/components/LinkBodyV2";
import analytics from "~/services/analytics";
import WatchButton from "~/components/Marketing/components/WatchButton";
import { TestimonialWrapper } from "./LandingPageTemplate.styles";
var mediaQueries = mixins.mediaQueries;
var MarketingLink = function(_param) /*#__PURE__*/ {
    var children = _param.children, rest = _object_without_properties(_param, [
        "children"
    ]);
    return _jsx(LinkBody, _object_spread_props(_object_spread({}, rest), {
        newTab: rest.href.startsWith("http://") || rest.href.startsWith("https://"),
        children: children
    }));
};
var getMarkdownComponents = function(color) {
    return {
        a: function(props) {
            return /*#__PURE__*/ _jsx(MarketingLink, _object_spread_props(_object_spread({}, props), {
                color: color
            }));
        },
        p: function(props) {
            return /*#__PURE__*/ _jsx(ResponsiveText, _object_spread_props(_object_spread({}, props), {
                color: color,
                variant: "body"
            }));
        }
    };
};
var contentMapper = function(param) {
    var content = param.content, index = param.index, NextImage = param.NextImage, openVideoModal = param.openVideoModal;
    switch(content.type){
        case "landingPageHeader":
            {
                var props = {
                    title: content.title
                };
                if (content.showAuthForm) {
                    props.cta = /*#__PURE__*/ _jsx(Signup, {});
                }
                if (content.subtitle) {
                    props.subtitle = /*#__PURE__*/ _jsx(MarkDown, {
                        components: getMarkdownComponents(),
                        content: content.subtitle
                    }, "".concat(content.type, "-").concat(index, "-0-subtitle"));
                }
                return /*#__PURE__*/ _jsx(Header, _object_spread({}, props), "".concat(content.type, "-").concat(index));
            }
        case "landingPageHighlight":
            {
                var props1 = {
                    title: content.title,
                    body: content.subtitle,
                    cta: {
                        url: content.linkUrl,
                        title: content.linkTitle
                    }
                };
                return /*#__PURE__*/ _jsx(Highlight, _object_spread({}, props1), "".concat(content.type, "-").concat(index));
            }
        case "landingPageTextAndMedia":
            {
                var props2 = {
                    header: content.title,
                    subtitle: content.subtitle && /*#__PURE__*/ _jsx(MarkDown, {
                        components: getMarkdownComponents(),
                        content: content.subtitle
                    }),
                    color: content.backgroundColor,
                    reverse: content.textFirst
                };
                if (content.media) {
                    if (content.media.type === "responsiveImage") {
                        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
                        var aspectRatio = (((ref = content.media) === null || ref === void 0 ? void 0 : (ref1 = ref.image) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.dimensions) === null || ref2 === void 0 ? void 0 : ref2.width) || 1) / (((ref3 = content.media) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.image) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.dimensions) === null || ref5 === void 0 ? void 0 : ref5.height) || 1);
                        props2.image = /*#__PURE__*/ _jsx(ContainerImage640x560, {
                            aspectRatio: aspectRatio,
                            children: /*#__PURE__*/ _jsx(NextImage, {
                                alt: ((ref6 = content.media.image) === null || ref6 === void 0 ? void 0 : ref6.description) || "",
                                src: (ref7 = content.media.image) === null || ref7 === void 0 ? void 0 : ref7.url,
                                layout: "fill",
                                sizes: "".concat(mediaQueries.belowLarge, " 100vw, 50vw")
                            })
                        });
                    // TODO: support smallImage
                    }
                    if (content.media.type === "responsiveVideo") {
                        var ref8;
                        props2.image = /*#__PURE__*/ _jsx(Video640x560, {
                            autoPlay: true,
                            loop: true,
                            muted: true,
                            playsInline: true,
                            src: (ref8 = content.media.video) === null || ref8 === void 0 ? void 0 : ref8.url,
                            poster: content.media.poster
                        });
                    // TODO: support smallVideo
                    }
                }
                if (content.quote) {
                    var ref9;
                    props2.name = content.quote.name;
                    props2.role = content.quote.jobTitle;
                    props2.quote = content.quote.quote;
                    props2.avatar = /*#__PURE__*/ _jsx(Avatar, {
                        src: (ref9 = content.quote.image) === null || ref9 === void 0 ? void 0 : ref9.url,
                        NextImage: NextImage
                    });
                }
                return /*#__PURE__*/ _jsx(ImageBlock, _object_spread({}, props2), "".concat(content.type, "-").concat(index));
            }
        case "responsiveImage":
            {
                var ref10;
                var props3 = {
                    NextImage: NextImage
                };
                if (content.image) {
                    var ref11, ref12, ref13, ref14;
                    props3.largeImage = {
                        src: content.image.url,
                        height: (ref11 = content.image.dimensions) === null || ref11 === void 0 ? void 0 : ref11.height,
                        width: (ref12 = content.image.dimensions) === null || ref12 === void 0 ? void 0 : ref12.width,
                        aspectRatio: (((ref13 = content.image.dimensions) === null || ref13 === void 0 ? void 0 : ref13.width) || 1) / (((ref14 = content.image.dimensions) === null || ref14 === void 0 ? void 0 : ref14.height) || 1)
                    };
                }
                if (content.smallImage) {
                    var ref15, ref16, ref17, ref18;
                    props3.smallImage = {
                        src: content.smallImage.url,
                        height: (ref15 = content.smallImage.dimensions) === null || ref15 === void 0 ? void 0 : ref15.height,
                        width: (ref16 = content.smallImage.dimensions) === null || ref16 === void 0 ? void 0 : ref16.width,
                        aspectRatio: (((ref17 = content.smallImage.dimensions) === null || ref17 === void 0 ? void 0 : ref17.width) || 1) / (((ref18 = content.smallImage.dimensions) === null || ref18 === void 0 ? void 0 : ref18.height) || 1)
                    };
                }
                return /*#__PURE__*/ _jsx(HeroImage, _object_spread({
                    alt: (ref10 = content.image) === null || ref10 === void 0 ? void 0 : ref10.description
                }, props3), "".concat(content.type, "-").concat(index));
            }
        case "faqs":
            {
                var components = {
                    a: FaqBlockLink,
                    img: function(param) {
                        var src = param.src, alt = param.alt;
                        return /*#__PURE__*/ _jsx(FaqBlockImage, {
                            src: src,
                            alt: alt,
                            NextImage: NextImage
                        });
                    },
                    li: FaqBlockLi,
                    ol: FaqBlockOl,
                    p: FaqBlockText,
                    ul: FaqBlockUl
                };
                var props4 = {
                    header: content.title,
                    faqList: content.faqs ? content.faqs.map(function(faq) {
                        return {
                            question: faq.question,
                            answer: faq.answer ? /*#__PURE__*/ _jsx(MarkDown, {
                                components: components,
                                content: faq.answer
                            }) : null
                        };
                    }) : []
                };
                return /*#__PURE__*/ _jsx(FaqBlock, _object_spread({}, props4), "".concat(content.type, "-").concat(index));
            }
        case "landingPageCtaRow":
            {
                var props5 = {
                    title: content.title,
                    subtitle2: content.subtitle && /*#__PURE__*/ _jsx(MarkDown, {
                        components: getMarkdownComponents("white"),
                        content: content.subtitle
                    }),
                    body2: content.body && /*#__PURE__*/ _jsx(MarkDown, {
                        components: getMarkdownComponents("white"),
                        content: content.body
                    })
                };
                if (content.showAuthForm) {
                    props5.cta = /*#__PURE__*/ _jsx(Signup, {});
                }
                return /*#__PURE__*/ _jsx(CTARow, _object_spread({}, props5), "".concat(content.type, "-").concat(index));
            }
        case "quote":
            {
                var ref19, ref20;
                var props6 = _object_spread({
                    altText: content.name,
                    quote: content.quote,
                    name: content.name,
                    role: content.jobTitle,
                    imgWebpSrc: (ref19 = content.image) === null || ref19 === void 0 ? void 0 : ref19.url,
                    imgFallbackSrc: (ref20 = content.image) === null || ref20 === void 0 ? void 0 : ref20.url
                }, content.embedYoutubeVideoId && content.embedLinkText ? {
                    watchButton: /*#__PURE__*/ _jsx(WatchButton, {
                        label: content.embedLinkText,
                        onClick: function() {
                            return openVideoModal(content.embedYoutubeVideoId);
                        }
                    })
                } : {});
                return /*#__PURE__*/ _jsx(TestimonialWrapper, {
                    children: /*#__PURE__*/ _jsx(Testimonial, _object_spread({
                        NextImage: NextImage
                    }, props6))
                }, "".concat(content.type, "-").concat(index));
            }
        case "usp":
            {
                var props7 = {
                    title: content.title,
                    backgroundColor: content.backgroundColor,
                    cards: content.cards
                };
                return /*#__PURE__*/ _jsx(Usp, _object_spread({
                    NextImage: NextImage
                }, props7), "".concat(content.type, "-").concat(index));
            }
        default:
            return null;
    }
};
var mapper = function(param) {
    var content = param.content, NextImage = param.NextImage, openVideoModal = param.openVideoModal;
    return content === null || content === void 0 ? void 0 : content.map(function(eachContent, index) {
        return contentMapper({
            content: eachContent,
            index: index,
            NextImage: NextImage,
            openVideoModal: openVideoModal
        });
    });
};
var LandingPageTemplate = function(param) {
    var data = param.data, NextImage = param.NextImage;
    var ref = useState(undefined), videoId = ref[0], setVideoId = ref[1];
    var openVideoModal = useCallback(function(id) {
        return setVideoId(id);
    }, []);
    var closeVideoModal = useCallback(function() {
        return setVideoId(undefined);
    }, []);
    useEffect(function() {
        analytics.page(analytics.events.category.MARKETING, data.title);
    }, [
        data.title
    ]);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            mapper({
                content: data.content,
                NextImage: NextImage,
                openVideoModal: openVideoModal
            }),
            /*#__PURE__*/ _jsx(FullscreenVideoModal, {
                isOpen: !!videoId,
                onRequestClose: closeVideoModal,
                youtubeVideoId: videoId
            })
        ]
    });
};
export default LandingPageTemplate;
